export interface QuickInputCategory {
  id: string
  title: string
  description: string
  groups: QuickInputGroup[]
}

export interface QuickInputGroup {
  id: string
  title: string
  chars: string
  words?: string[]
  description?: string
  type: 'char' | 'word'
}

export const QUICK_INPUT_CATEGORIES: QuickInputCategory[] = [
  {
    id: 'daily-life',
    title: 'Daily Life',
    description: 'Common words for everyday situations',
    groups: [
      {
        id: 'greetings',
        title: 'Greetings',
        type: 'word',
        chars: '你好再见谢谢对不起没关系请问好的',
        words: ['你好', '再见', '谢谢', '对不起', '没关系', '请问', '好的'],
        description: 'Hello, goodbye, thank you, sorry',
      },
      {
        id: 'numbers',
        title: 'Numbers 1-20',
        type: 'char',
        chars: '一二三四五六七八九十百千万零个十百千万亿',
        description: 'Basic numbers and counting',
      },
      {
        id: 'time',
        title: 'Time & Date',
        type: 'word',
        chars: '年月日星期今天昨天明天早上中午晚上现在几点钟',
        words: ['年月', '星期', '今天', '昨天', '明天', '早上', '中午', '晚上', '现在', '几点', '点钟'],
        description: 'Time expressions',
      },
      {
        id: 'family',
        title: 'Family',
        type: 'word',
        chars: '爸爸妈妈哥哥姐姐弟弟妹妹儿子女儿丈夫妻子朋友',
        words: ['爸爸', '妈妈', '哥哥', '姐姐', '弟弟', '妹妹', '儿子', '女儿', '丈夫', '妻子', '朋友'],
        description: 'Family members',
      },
      {
        id: 'food',
        title: 'Food & Drinks',
        type: 'word',
        chars: '米饭面条饺子包子面包水果蔬菜肉鱼鸡蛋牛奶茶咖啡水',
        words: ['米饭', '面条', '饺子', '包子', '面包', '水果', '蔬菜', '肉鱼', '鸡蛋', '牛奶', '茶咖', '啡水'],
        description: 'Common foods and drinks',
      },
      {
        id: 'colors',
        title: 'Colors',
        type: 'word',
        chars: '红色橙色黄色绿色蓝色紫色白色黑色粉色灰色棕色',
        words: ['红色', '橙色', '黄色', '绿色', '蓝色', '紫色', '白色', '黑色', '粉色', '灰色', '棕色'],
        description: 'Basic colors',
      },
      {
        id: 'emotions',
        title: 'Emotions',
        type: 'word',
        chars: '开心难过生气害怕喜欢爱讨厌累饿渴冷热痛',
        words: ['开心', '难过', '生气', '害怕', '喜欢', '讨厌', '累饿', '渴冷', '热痛'],
        description: 'Common emotions and feelings',
      },
      {
        id: 'directions',
        title: 'Directions',
        type: 'word',
        chars: '上下左右前后东南西北内外旁边远近这里那里',
        words: ['上下', '左右', '前后', '东南', '西北', '内外', '旁边', '远近', '这里', '那里'],
        description: 'Directions and positions',
      },
    ],
  },
  {
    id: 'travel',
    title: 'Travel in China',
    description: 'Essential vocabulary for traveling in China',
    groups: [
      {
        id: 'airport',
        title: 'Airport',
        type: 'word',
        chars: '机场飞机航班登机牌护照签证行李托运安检登机口起飞降落',
        words: ['机场', '飞机', '航班', '登机', '护照', '签证', '行李', '托运', '安检', '登机', '起飞', '降落'],
        description: 'Airport and flight terms',
      },
      {
        id: 'hotel',
        title: 'Hotel',
        type: 'word',
        chars: '酒店宾馆房间预订入住退房前台钥匙房卡单人间双人间卫生间',
        words: ['酒店', '宾馆', '房间', '预订', '入住', '退房', '前台', '钥匙', '房卡', '单人', '双人', '卫生'],
        description: 'Hotel and accommodation',
      },
      {
        id: 'transport',
        title: 'Transportation',
        type: 'word',
        chars: '地铁公交车出租车火车高铁飞机站路票线换乘票价',
        words: ['地铁', '公交', '出租', '火车', '高铁', '飞机', '车站', '路线', '换乘', '票价'],
        description: 'Public transportation',
      },
      {
        id: 'restaurant',
        title: 'Restaurant',
        type: 'word',
        chars: '餐厅菜单点菜服务员买单筷子勺子叉子碗盘子茶水推荐特色',
        words: ['餐厅', '菜单', '点菜', '服务', '买单', '筷子', '勺子', '叉子', '碗盘', '茶水', '推荐', '特色'],
        description: 'Dining out',
      },
      {
        id: 'shopping',
        title: 'Shopping',
        type: 'word',
        chars: '商店买东西多少钱太贵便宜打折刷卡现金支付宝微信支付找钱',
        words: ['商店', '买东西', '多少', '太贵', '便宜', '打折', '刷卡', '现金', '支付', '微信', '找钱'],
        description: 'Shopping phrases',
      },
      {
        id: 'emergency',
        title: 'Emergency',
        type: 'word',
        chars: '帮助医院医生药店警察报警火救护车急救电话危险小心',
        words: ['帮助', '医院', '医生', '药店', '警察', '报警', '救护', '急救', '电话', '危险', '小心'],
        description: 'Emergency phrases',
      },
      {
        id: 'sightseeing',
        title: 'Sightseeing',
        type: 'word',
        chars: '景点门票导游地图拍照厕所入口出口开放时间游客中心',
        words: ['景点', '门票', '导游', '地图', '拍照', '厕所', '入口', '出口', '开放', '游客', '中心'],
        description: 'Tourist attractions',
      },
      {
        id: 'cities',
        title: 'Famous Cities',
        type: 'word',
        chars: '北京上海广州深圳杭州西安成都重庆苏州南京',
        words: ['北京', '上海', '广州', '深圳', '杭州', '西安', '成都', '重庆', '苏州', '南京'],
        description: 'Major Chinese cities',
      },
    ],
  },
  {
    id: 'poetry',
    title: 'Chinese Poetry',
    description: 'Classic poems from Chinese literature',
    groups: [
      {
        id: 'tang-poems-1',
        title: 'Tang Poems I',
        type: 'char',
        chars: '床前明月光疑是地上霜举头望明月低头思故乡',
        description: '静夜思 - Li Bai',
      },
      {
        id: 'tang-poems-2',
        title: 'Tang Poems II',
        type: 'char',
        chars: '春眠不觉晓处处闻啼鸟夜来风雨声花落知多少',
        description: '春晓 - Meng Haoran',
      },
      {
        id: 'tang-poems-3',
        title: 'Tang Poems III',
        type: 'char',
        chars: '白日依山尽黄河入海流欲穷千里目更上一层楼',
        description: '登鹳雀楼 - Wang Zhihuan',
      },
      {
        id: 'tang-poems-4',
        title: 'Tang Poems IV',
        type: 'char',
        chars: '千山鸟飞绝万径人踪灭孤舟蓑笠翁独钓寒江雪',
        description: '江雪 - Liu Zongyuan',
      },
      {
        id: 'tang-poems-5',
        title: 'Tang Poems V',
        type: 'char',
        chars: '锄禾日当午汗滴禾下土谁知盘中餐粒粒皆辛苦',
        description: '悯农 - Li Shen',
      },
      {
        id: 'song-poems-1',
        title: 'Song Poems I',
        type: 'char',
        chars: '明月几时有把酒问青天不知天上宫阙今夕是何年',
        description: '水调歌头 - Su Shi',
      },
      {
        id: 'song-poems-2',
        title: 'Song Poems II',
        type: 'char',
        chars: '寻寻觅觅冷冷清清凄凄惨惨戚戚',
        description: '声声慢 - Li Qingzhao',
      },
      {
        id: 'famous-lines',
        title: 'Famous Lines',
        type: 'char',
        chars: '学而时习之不亦说乎有朋自远方来不亦乐乎',
        description: 'The Analects',
      },
    ],
  },
  {
    id: 'landmarks',
    title: 'Landmarks',
    description: 'Famous Chinese landmarks and cultural sites',
    groups: [
      {
        id: 'great-wall',
        title: 'Great Wall',
        type: 'word',
        chars: '长城万里长城秦始皇明朝八达岭慕田峪司马台',
        words: ['长城', '万里', '秦始皇', '明朝', '八达', '慕田', '司马'],
        description: 'The Great Wall of China',
      },
      {
        id: 'forbidden-city',
        title: 'Forbidden City',
        type: 'word',
        chars: '故宫紫禁城太和殿乾清宫午门角楼',
        words: ['故宫', '紫禁城', '太和', '乾清', '午门', '角楼'],
        description: 'The Forbidden City in Beijing',
      },
      {
        id: 'terracotta',
        title: 'Terracotta Army',
        type: 'word',
        chars: '兵马俑秦始皇陵西安陶俑铜车马',
        words: ['兵马俑', '秦始皇', '西安', '陶俑', '铜车'],
        description: 'Terracotta Army in Xi\'an',
      },
      {
        id: 'west-lake',
        title: 'West Lake',
        type: 'word',
        chars: '西湖杭州断桥残雪雷峰塔苏堤春晓三潭印月',
        words: ['西湖', '杭州', '断桥', '雷峰', '苏堤', '三潭'],
        description: 'West Lake in Hangzhou',
      },
      {
        id: 'potala',
        title: 'Potala Palace',
        type: 'word',
        chars: '布达拉宫拉萨西藏喇嘛红宫白宫',
        words: ['布达拉', '拉萨', '西藏', '喇嘛', '红宫', '白宫'],
        description: 'Potala Palace in Lhasa',
      },
      {
        id: 'yellow-mountain',
        title: 'Yellow Mountain',
        type: 'word',
        chars: '黄山安徽奇松怪石云海温泉迎客松天都峰',
        words: ['黄山', '安徽', '奇松', '怪石', '云海', '温泉', '迎客', '天都'],
        description: 'Yellow Mountain in Anhui',
      },
      {
        id: 'giant-panda',
        title: 'Giant Panda',
        type: 'word',
        chars: '大熊猫熊猫成都动物园竹子黑眼圈国宝',
        words: ['大熊猫', '熊猫', '成都', '动物', '竹子', '黑眼', '国宝'],
        description: 'Giant Panda in Chengdu',
      },
      {
        id: 'silk-road',
        title: 'Silk Road',
        type: 'word',
        chars: '丝绸之路敦煌莫高窟月牙泉嘉峪关新疆驼队贸易',
        words: ['丝绸', '之路', '敦煌', '莫高', '月牙', '嘉峪', '新疆', '驼队', '贸易'],
        description: 'The ancient Silk Road',
      },
    ],
  },
  {
    id: 'hsk',
    title: 'HSK Vocabulary',
    description: 'HSK (Chinese Proficiency Test) vocabulary lists',
    groups: [
      {
        id: 'hsk1',
        title: 'HSK Level 1',
        type: 'word',
        chars: '我叫是大学生老师中国人朋友家在北京喜欢喝茶吃米饭看书写字画画听音乐看电影',
        words: ['我叫', '学生', '老师', '中国', '朋友', '北京', '喜欢', '喝茶', '米饭', '看书', '写字', '画画', '音乐', '电影'],
        description: '150 words - beginner level',
      },
      {
        id: 'hsk2',
        title: 'HSK Level 2',
        type: 'word',
        chars: '飞机火车站出租车旅馆医院超市商场银行邮局邮箱手机电脑互联网电子邮件',
        words: ['飞机', '火车', '出租', '旅馆', '医院', '超市', '商场', '银行', '邮局', '邮箱', '手机', '电脑', '互联', '邮件'],
        description: '300 words - elementary',
      },
      {
        id: 'hsk3',
        title: 'HSK Level 3',
        type: 'word',
        chars: '总是发现变介绍同意准备经理问题办法刚才突然担心清楚超过关心照顾',
        words: ['总是', '发现', '介绍', '同意', '准备', '经理', '问题', '办法', '刚才', '突然', '担心', '清楚', '超过', '关心', '照顾'],
        description: '600 words - intermediate',
      },
      {
        id: 'hsk4',
        title: 'HSK Level 4',
        type: 'word',
        chars: '随着期间坚持情况当时提供部分由于因此所谓不仅向除了分析比较经验',
        words: ['随着', '期间', '坚持', '情况', '当时', '提供', '部分', '由于', '因此', '所谓', '不仅', '除了', '分析', '比较', '经验'],
        description: '1200 words - upper intermediate',
      },
    ],
  },
  {
    id: 'self-intro',
    title: 'Self Introduction',
    description: 'Common phrases for introducing yourself',
    groups: [
      {
        id: 'basic-intro',
        title: 'Basic Intro',
        type: 'word',
        chars: '我叫我来自我是学生老师我喜欢吃辣口味淡我不太能吃辣我过敏',
        words: ['我叫', '来自', '学生', '老师', '喜欢', '口味', '不太', '过敏'],
        description: 'Basic self-introduction',
      },
      {
        id: 'hobbies',
        title: 'Hobbies',
        type: 'word',
        chars: '我喜欢唱歌跳舞画画书法游泳跑步爬山看电影听音乐旅游摄影',
        words: ['唱歌', '跳舞', '画画', '书法', '游泳', '跑步', '爬山', '电影', '音乐', '旅游', '摄影'],
        description: 'Talking about hobbies',
      },
      {
        id: 'work',
        title: 'Work & Study',
        type: 'word',
        chars: '我在学习中文我在工作我是工程师医生设计师老师学生',
        words: ['学习', '中文', '工作', '工程', '医生', '设计', '老师', '学生'],
        description: 'Work and study',
      },
      {
        id: 'countries',
        title: 'Countries',
        type: 'word',
        chars: '美国英国法国德国日本韩国泰国新加坡马来西亚澳大利亚加拿大',
        words: ['美国', '英国', '法国', '德国', '日本', '韩国', '泰国', '新加坡', '马来', '澳大利亚', '加拿大'],
        description: 'Country names',
      },
    ],
  },
]
